import { State, Action, StateContext } from '@ngxs/store';
import { InstituteDetailsResponse } from '../../models/institute/instituteDetailResponse';
import { InstituteDetailModel } from './institute-detail-model';

export class AddInstituteDetail {
  static readonly type = '[AddInstituteDetail] Add Detail';
  constructor(public payload: {item:InstituteDetailModel}) {}
}
